"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Languages = void 0;
const Languages = exports.Languages = {
  EN_US: "en-US",
  PT_BR: "pt-BR",
  ES_MX: "es-MX"
};